"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var data_1 = require("../data");
var ListCrud = function (props) {
    var ListUI = props.ListUI, FormUI = props.FormUI, promise = props.promise, _a = props.initData, initData = _a === void 0 ? [] : _a, restOfProps = __rest(props, ["ListUI", "FormUI", "promise", "initData"]);
    var _b = react_1["default"].useState(initData), listData = _b[0], setListData = _b[1];
    var _c = react_1["default"].useState(null), formData = _c[0], setFormData = _c[1];
    var handleDelete = function (uuid) {
        setListData(listData.filter(function (_) { return _.uuid !== uuid; }));
    };
    var handleAdd = function () {
        setFormData({});
    };
    var handleUpdate = function (d, resultFromBackend) {
        if (!d.id) {
            var e = listData.concat([__assign(__assign({}, d), resultFromBackend)]);
            setListData(e);
            return;
        }
        setListData(listData.map(function (x) {
            if (x.uuid === d.id) {
                return d;
            }
            return x;
        }));
    };
    if (formData === null) {
        return (react_1["default"].createElement(react_1["default"].Fragment, null,
            react_1["default"].createElement(ListUI, __assign({ data: listData, onClick: function (d) { return setFormData(d); }, onDelete: handleDelete }, restOfProps)),
            react_1["default"].createElement("button", { onClick: handleAdd }, "Add")));
    }
    return (react_1["default"].createElement(data_1.Form, { UI: FormUI, data: formData, promise: promise, onUpdate: handleUpdate, onToggle: function () { return setFormData(null); } }));
};
exports["default"] = ListCrud;
